import * as models from '../models'; 

export function encodeQueryString(reqeuestObject: any) {
    const querystring = require('query-string'); 
    let queryString = querystring.stringify(reqeuestObject, {skipNull: true}); 
    return queryString; 
}

export function getAuthUsername() {
    let token = localStorage.getItem('token');
    if (token) {
        //console.log("token: " + token);
        var tokenInfo = parseJwt(token);
        return parseJwt(token).sub;
    }
    return null;
}

// Returns true if the current user has the defined permission
export function userHasPermission(permissionName: string): boolean {
    let userInfo = getUserInfo();
    if (! userInfo || ! userInfo.permissions) return false;
    return userInfo.permissions.indexOf(permissionName) > -1;
}

export function getUserPermissions(): string[] {
    let userInfo = getUserInfo();
    if (!userInfo || !userInfo.permissions) return [];
    return userInfo.permissions;
}

export function getUserInfo() {
    let userInfoStr = localStorage.getItem('userInfo');
    if (userInfoStr) {
        const thisUser: models.UserInfo = JSON.parse(userInfoStr); 
        return thisUser
    } 
    return null;
}

function parseJwt (token: string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
};

export function getLocalToken() {
    const token = localStorage.getItem('token'); 
    if (token === null || token === undefined) {
        return; 
    }
    return token; 
}

export function roundTo(num: number, places: number) {
    const factor = 10 ** places; 
    return Math.round(num * factor) / factor; 
}; 

export function getErrorsFromAPIResponse(responseData: any) {    
    const errorMessage = (responseData.Message || responseData.message) ?? responseData;     
    const innerException = responseData.InnerException?.Message ?? ""; 
    return errorMessage + "\r\n\r\n" + innerException; 
}

export function getErrorsFromAPIResponse2(responseData: any) {
    const errorMessage = responseData.data.Message ?? responseData; 
    const innerException = responseData.data.InnerException?.Message ?? ""; 
    return innerException !== "" ? innerException : errorMessage; 
}

export function get400Errors(responseData: any) {    
    const errorMessage = responseData.title;     
    const reasons = responseData.errors.reason.map((r:any) => r).join(', '); 
    return errorMessage + "\r\n\r\n" + reasons; 
}

export function getResponseErrors(responseData: any) {  
    const status = responseData.status;     
    switch (status) {
        case 400: 
            return get400Errors(responseData); 
        case 401:
            return responseData.data.message; 
        case 415: 
            return responseData.title; 
        case 500:
            return getErrorsFromAPIResponse2(responseData); 
        default: 
            return getErrorsFromAPIResponse(responseData); 
    }
}

export function nFormatter(num:number, digits:number, prefix?: string) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" }
    ];    
    const regexp = /\.0+$|(?<=\.*)0+$/;

  // Determine the sign of the number
  const sign = Math.sign(num) === -1? "-": "";
  // Take the absolute value of the number for lookup
  const absNum = Math.abs(num);
  const item = lookup.slice().reverse().find(item => absNum >= item.value);
  return item
  ? prefix + sign + (absNum / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol)
  : "0";
  }

export function parseApiError(data: any): string {
    if (!data) return "An unexpected error occurred.";
    
    // 1. If it's just a raw string
    if (typeof data === 'string') return data;

    // 2. Preferred standard object
    if (data.message) return data.message;
    if (data.Message) return data.Message;

    // 3. Standard .NET ProblemDetails
    if (data.errors) {
        try {
            // Object.values returns an array of string arrays: [["Error 1"], ["Error 2", "Error 3"]]
            // We reduce it to a single array: ["Error 1", "Error 2", "Error 3"]
            const allErrors = Object.values(data.errors).reduce((acc: any[], curr: any) => {
                return acc.concat(curr);
            }, []);
            
            return allErrors.join(', ');
        } catch (e) {
            return data.title || "Validation failed";
        }
    }
    if (data.title) return data.title;

    // 4. Legacy nested format
    if (data.error?.message) return data.error.message;

    // 5. Fallback
    return "An unknown server error occurred.";
}